import { useEffect } from "react";
import { useAppSelector } from "../../App/hooks";
import useRequest from "../../Hooks/useRequest";
import { getDeltaHedgeOrderBook } from "../../Requests/deltaHedgeOrder";
import OrderBookTable from "../../Tables/Order/OrderBookTable";
import { GetBookOrderResponse } from "../../Interfaces/nLegsInterfaces";
import { StepOrderSide } from "../../Interfaces/stepInterfaces";
import { addSeperatorToInput } from "../../helper";
import useLiveOrderBooks from "../../Hooks/useLiveOrderBooks";

const OrderBook = () => {
  const formValues = useAppSelector(
    (store) => store.deltaHedgeOrder.addOrderFormValues,
  );
  console.log(
    `orderbook orderSide1 orderSide2  ${formValues?.orderSide1} ${formValues?.orderSide2}`,
  );
  const orderBookRequest = useRequest(
    () =>
      getDeltaHedgeOrderBook({
        ins1: formValues?.instrumentId1 || "",
        ins2: formValues?.instrumentId2 || "",
        orderSide1: formValues?.orderSide1!,
        orderSide2: formValues?.orderSide2!,
      }),

    (e) => {},
  );
  const liveOrderBooks = useLiveOrderBooks({
    enabled: true,
    instrumentIds: [formValues?.instrumentId1, formValues?.instrumentId2],
  });

  useEffect(() => {
    if (!formValues?.instrumentId1 || !formValues.instrumentId2) return;
    orderBookRequest.fetchData();
    const interval = setInterval(() => {
      orderBookRequest.fetchData();
    }, 10000);
    return () => clearInterval(interval);
  }, [formValues]);

  const getOrderbookValues = (
    values?: GetBookOrderResponse[],
  ): GetBookOrderResponse[] => {
    if (!values || !values.length) return new Array(2).fill(null as any);

    if (values.length < 2) {
      const res: GetBookOrderResponse[] = [...values];
      for (let index = 0; index < 2 - values.length; index++) {
        res.push(null as any);
      }
      return res;
    }
    return values;
  };

  return (
    <div className="flex flex-col justify-start items-center gap-3 min-h-[225px]">
      <div className="flex flex-row justify-start items-center">
        {getOrderbookValues(orderBookRequest?.response?.orderBooks)?.map(
          (resp) => (
            <div className="mx-0.5">
              <OrderBookTable
                tableInfo={liveOrderBooks.resolveOrderBook(resp?.fullOrderBook)}
              />
            </div>
          ),
        )}
      </div>
      <div className="flex flex-row justify-start items-center gap-5">
        <div className="">بهای تمام شده:</div>

        {orderBookRequest?.response?.totalPrices?.map((totalPrice, tI) => (
          <div className="flex flex-row justify-start items-center">
            {totalPrice?.ratios?.map((r, i) => (
              <>
                <div
                  className={`${
                    r.orderSide === StepOrderSide.Buy
                      ? "text-green-700"
                      : r.orderSide === StepOrderSide.Sell
                        ? "text-red-700"
                        : "text-gray-600"
                  }`}
                >
                  {r.ratio}
                </div>
                {totalPrice.ratios.length !== i + 1 ? (
                  <>-</>
                ) : (
                  <div
                    className={`mr-5 ltr ${
                      orderBookRequest?.response?.totalPrices.length !== tI + 1
                        ? "border-l-[1px] border-gray-600 pl-5"
                        : ""
                    }`}
                  >
                    {addSeperatorToInput(
                      totalPrice.price,
                      "negativeDecimalNumbers",
                    )}
                  </div>
                )}
              </>
            ))}
          </div>
        ))}
      </div>
      <div className="flex flex-row justify-start items-center gap-5">
        <div className="flex flex-row justify-start items-center gap-1">
          <div>%بازده قفل:</div>
          <div>{orderBookRequest.response?.info?.dailyLockProfitPercent}</div>
        </div>
        <div className="flex flex-row justify-start items-center gap-1">
          <div>%بازده قفل آفست:</div>
          {orderBookRequest.response?.info?.dailyLockProfitPercentOffset}
        </div>
      </div>
    </div>
  );
};

export default OrderBook;
